export const FetchEntitlementsForCartQuery = `
query fetchEntitlementsForCart($id: ID!, $filterOptions: [FilterOption], $searchOptions: ConnectionSearchOptions, $isRestricted: Boolean, $fetchECCFromIdentity: Boolean = true) {
    transactionAccount(id: $id) {
      id
      partnerAccountId
      billingAdmins {
        nodes {
          email
          fullName
          atlassianAccountId
        }
      }
      productSubscriptions(filterOptions: $filterOptions, searchOptions: $searchOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          transactionAccountId
          cloudSiteId
          cloudSiteHostname
          productName
          productId
          offeringId
          offering {
            name
            level
            relationshipRequirements {
              side
              level
              type
            }
          }
          edition
          pricingPlanId
          pricingPlan {
            id
            type
            pricingPlanType
            currency
          }
          isFutureDatedSubscription
          endCustomerContacts(isRestricted: $isRestricted) @include(if: $fetchECCFromIdentity) {
            accountId
            email
            name
            picture
          }
          entitlementNumber
          logoId
          latestPeriodEndDate
          relatesFromEntitlements {
            relationshipType
            entitlementId
          }
          id
          orgId
          orgName
          activeUsers
          billingFrequency
          baseProduct
          createdDate
          billingStatus
          provisioningStatus
          billingGroupId
          billedUsers
          trial
          isApp
          isSandbox
          nextBillingAnchorTimestamp:nextBillingTimestamp
          nextBillingTimestamp:nextBillingTimestampForScheduledUpgrades
          relatesToEntitlements {
            relationshipType
            entitlementId
          }
          linkedAppsId
          promotions {
            id
            title
            type
            promotionCode
            benefits {
              benefitType
              duration
              subBenefitType
              iterations
              value
              values {
                appliedOn
                value
              }
              scale
              type
              customisable {
                value {
                  type
                  lowerBound
                  upperBound
                }
                iterations {
                  type
                  lowerBound
                  upperBound
                }
                duration
              }
            }
            promotionInstanceId
            status
            cycleInterval
            pricingType
            eligibilityRules {
              products
              cycleInterval
              pricingType
              partnerType
              partnerTier
              saleTransitionType
              currency
            }
            cycleIntervalWithEligibleConditions
            applicationReason {
              id
              readableName
              customisable {
                id {
                  type
                  anyOf {
                    readableName
                    id
                  }
                }
              }
            }
            isPromotionCustomisable
            benefitStates {
              benefitEnd
              percentageOff
            }
          }
          isPartnerEntitlement
          isAddOn
          isOnUpgradeTrial
        }
      }
    }
  }
`;

export const FetchEntitlementsForCartInitialLoadQuery = `
query fetchEntitlementsForCartInitialLoad($id: ID!, $filterOptions: [FilterOption], $searchOptions: ConnectionSearchOptions) {
    transactionAccount(id: $id) {
      id
      productSubscriptions(filterOptions: $filterOptions, searchOptions: $searchOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          transactionAccountId
          cloudSiteId
          cloudSiteHostname
          productName
          productId
          offeringId
          edition
          pricingPlanId
          entitlementNumber
          logoId
          latestPeriodEndDate
          relatesFromEntitlements {
            relationshipType
            entitlementId
          }
          id
          billingGroupId
          isApp
          trial
        }
      }
    }
  }
`;

export const EnrichEntitlementsForCartQuery = `
query enrichEntitlementsForCart($id: ID!, $filterOptions: [FilterOption], $searchOptions: ConnectionSearchOptions, $isRestricted: Boolean) {
  transactionAccount(id: $id) {
    id
    productSubscriptions(filterOptions: $filterOptions, searchOptions: $searchOptions) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        cloudSiteHostname
        edition
        endCustomerContacts(isRestricted: $isRestricted) {
          accountId
          email
          name
          picture
        }
        id
        activeUsers
        billingFrequency
        baseProduct
        createdDate
        billingStatus
        provisioningStatus
        isApp
        nextBillingAnchorTimestamp:nextBillingTimestamp
        nextBillingTimestamp:nextBillingTimestampForScheduledUpgrades
        relatesFromEntitlements {
          relationshipType
          entitlementId
        }
        relatesToEntitlements {
          relationshipType
          entitlementId
        }
        promotions {
          id
          title
          type
          promotionCode
          benefits {
            benefitType
            duration
            subBenefitType
            iterations
            value
            scale
            type
            customisable {
              value {
                type
                lowerBound
                upperBound
              }
              iterations {
                type
                lowerBound
                upperBound
              }
              duration
            }
          }
          promotionInstanceId
          status
          cycleInterval
          pricingType
          eligibilityRules {
            products
            cycleInterval
            pricingType
            partnerType
            partnerTier
            saleTransitionType
            currency
          }
          cycleIntervalWithEligibleConditions
          applicationReason {
            id
            readableName
            customisable {
              id {
                type
                anyOf {
                  readableName
                  id
                }
              }
            }
          }
          isPromotionCustomisable
        }
      }
    }
  }
}
`;
